
import { useEffect } from 'react';

declare global {
  interface Window {
    chatwootSettings?: {
      position: string;
      type: string;
      launcherTitle: string;
    };
    chatwootSDK?: {
      run: (config: { websiteToken: string; baseUrl: string }) => void;
    };
  }
}

const ChatwootWidget = () => {
  useEffect(() => {
    // Configure Chatwoot settings
    window.chatwootSettings = {
      position: "right",
      type: "expanded_bubble",
      launcherTitle: "Fale conosco no chat"
    };

    // Load Chatwoot script
    const BASE_URL = "https://cloudchat.cloudhumans.com";
    const script = document.createElement("script");
    script.src = `${BASE_URL}/packs/js/sdk.js`;
    script.defer = true;
    script.async = true;

    script.onload = () => {
      window.chatwootSDK?.run({
        websiteToken: 'rHjK2ycgC4i739VtQTPa1g7G',
        baseUrl: BASE_URL
      });
    };

    document.body.appendChild(script);

    // Cleanup function
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return null;
};

export default ChatwootWidget;
